import { createAction, props } from '@ngrx/store';
import { PaginatedResponse, User, UserProcess } from '@interfaces';
import { ManagerOfCompany, SearchProcessesOfManagedEmployees } from 'src/app/_interfaces/manager';

export const getMyManagedCompanies = createAction('[Manager] Get My Managed Companies');
export const getMyManagedCompaniesSuccess = createAction(
  '[Company Manager] Get My Managed Companies SUCCESS',
  props<{ managedCompanies: ManagerOfCompany[] }>()
);
export const getMyManagedCompaniesError = createAction(
  '[Company Manager] Get My Managed Companies ERROR',
  props<{ errorMessage: string }>()
);

export const searchProcessesOfManagedEmployees = createAction(
  '[Company Manager] Search Processes Of Managed Employees',
  props<{ opts: SearchProcessesOfManagedEmployees }>()
);
export const searchProcessesOfManagedEmployeesSuccess = createAction(
  '[Company Manager] Search Processes Of Managed Employees SUCCESS',
  props<{ processes: PaginatedResponse<Partial<UserProcess>> }>()
);
export const searchProcessesOfManagedEmployeesError = createAction(
  '[Company Manager] Search Processes Of Managed Employees ERROR',
  props<{ errorMessage: string }>()
);
